import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Navigation = ({ onReportClick }) => {
  const { t } = useLanguage();
  const location = useLocation();

  const menuItems = [
    { id: 'about', path: '/about', label: t('about') },
    { id: 'map', path: '/', label: t('map') },
    { id: 'help', path: '/help', label: t('help') },
    { id: 'wetlands-info', path: '/wetlands-info', label: t('wetlandsInfo') },
  ];

  return (
    <nav className="app-nav">
      <ul className="nav-menu">
        {menuItems.map((item) => (
          <li
            key={item.id}
            className={location.pathname === item.path ? 'active' : ''}
          >
            <Link to={item.path} className="nav-link">{item.label}</Link>
          </li>
        ))}
        {/* <li className="desktop-only" onClick={onReportClick} style={{ color: '#ff6b6b', cursor: 'pointer' }}>
          {t('report')}
        </li> */}
      </ul>
    </nav>
  );
};

export default Navigation;

